<template>
  <div class="answer-panel">
    <van-popup
      :close-on-click-overlay="false"
      @click-close-icon="close"
      :value="show"
      closeable
      position="bottom"
      :style="{maxHeight: '60%'}"
    >
      <div class="t">
        <div class="conatiner">答题卡</div>
        <template v-if="answer.objectType === 1">
          <van-form @submit="onSubmit">
            <div
              class="title-item"
              :class="{'title-item-answer': title.type === 3}"
              v-for="(title, index) in titles"
              :key="index"
            >
              <template v-if="title.type === 1">
                <van-field
                  :required="title.isMandatory === 1"
                  :rules="[{required: title.isMandatory === 1, message: '请选择'}]"
                >
                  <template #label>
                    <div class="title-head">
                      <span class="num">{{ title.sort }}.</span>
                      <span class="type">({{ typeLabel[title.type] }})</span>
                      <span class="name">{{ title.name }}</span>
                    </div>
                  </template>
                  <template #input>
                    <van-radio-group v-model="title.result">
                      <van-radio
                        :name="option.eventExamOptionsId"
                        v-for="option in title.options"
                        :key="option.eventExamOptionsId"
                        >{{ option.content }}</van-radio
                      >
                    </van-radio-group>
                  </template>
                </van-field>
              </template>
              <template v-if="title.type === 2">
                <van-field
                  :required="title.isMandatory === 1"
                  :rules="[{required: title.isMandatory === 1, message: '请选择'}]"
                >
                  <template #label>
                    <div class="title-head">
                      <span class="num">{{ title.sort }}.</span>
                      <span class="type">({{ typeLabel[title.type] }})</span>
                      <span class="name">{{ title.name }}</span>
                    </div>
                  </template>
                  <template #input>
                    <van-checkbox-group v-model="title.result">
                      <van-checkbox
                        :name="option.eventExamOptionsId"
                        v-for="option in title.options"
                        :key="option.eventExamOptionsId"
                        shape="square"
                        >{{ option.content }}</van-checkbox
                      >
                    </van-checkbox-group>
                  </template>
                </van-field>
              </template>
              <template v-if="title.type === 3">
                <van-field
                  v-model="title.result"
                  :rules="[{required: title.isMandatory === 1}]"
                  :required="title.isMandatory === 1"
                  placeholder="请输入您的答案"
                >
                  <template #label>
                    <div class="title-head">
                      <span class="num">{{ title.sort }}.</span>
                      <span class="type">({{ typeLabel[title.type] }})</span>
                      <span class="name">{{ title.name }}</span>
                    </div>
                  </template>
                </van-field>
              </template>
            </div>
            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
          </van-form>
        </template>
        <template v-else>
          <div class="option-container">
            <div
              :class="{radio: chooseType === 1, checkbox: chooseType === 2, active: option.checked}"
              class="option-item"
              v-for="(option, index) in options"
              :key="index"
              @click="select(index)"
            >
              {{ option.name }}
            </div>
          </div>
          <div style="margin: 16px;">
            <van-button @click="simpleSubmit" round block type="info" native-type="submit">提交</van-button>
          </div>
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {getbase, getsimple, baseSubmit, simpleSubmit} from '@/api'
export default {
  data() {
    return {
      typeLabel: ['', '单选', '多选', '问答'],
      titles: [],
      eventExamPaperRecordId: '',
      eventExamPaperId: '',
      // 快速答题
      options: [],
      titleId: '',
      chooseType: 0 // 1 单选 2多选
    }
  },
  computed: {
    answer() {
      return this.$store.state.activePlay.answer
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    isAuth() {
      return this.$store.getters.isAuth
    },
    show() {
      return this.answer.showPanel
    }
  },
  watch: {
    'answer.showPanel': {
      handler(val) {
        if (val) {
          const {objectId, objectType} = this.answer
          if (!objectId && !objectType) return false
          if (objectType === 1) {
            this.getComplex(objectId)
          } else {
            this.getSimple(objectId)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$store.commit('setAnswerInfo', {
        showPanel: false
      })
    },
    async getSimple(paperId) {
      const result = await getsimple({paperId, eventId: this.$route.params.id})
      this.options = result.data.options
      this.eventExamPaperRecordId = result.data.recordId
      this.eventExamPaperId = result.data.eventExamPaperId
      this.titleId = result.data.titleId
      this.chooseType = result.data.chooseType
    },
    async getComplex(paperId) {
      const result = await getbase({paperId, eventId: this.$route.params.id})
      if (result.code === 0) {
        this.titles = result.data.titles
        this.eventExamPaperRecordId = result.data.eventExamPaperRecordId
        this.eventExamPaperId = result.data.eventExamPaperId
      }
    },
    async onSubmit() {
      const titles = this.titles.map(title => {
        let chooses = []
        let answer = null
        if (title.type === 3) {
          answer = title.result
          chooses = []
        } else if (title.type === 1) {
          if (title.result) {
            chooses = [title.result]
          } else {
            chooses = []
          }
          answer = null
        } else {
          answer = null
          if (title.result) {
            chooses = title.result
          } else {
            chooses = []
          }
        }
        return {
          eventExamTitleId: title.eventExamTitleId,
          answer,
          chooses
        }
      })

      const data = {
        answerUserId: this.userInfo.id || +new Date(),
        eventExamPaperId: this.eventExamPaperId,
        recordId: this.eventExamPaperRecordId,
        titles
      }
      const result = await baseSubmit(data)
      if (result.code === 0) {
        this.$Toast.success('提交成功')
        this.$store.commit('setAnswerInfo', {
          showPanel: false
        })
      }
    },
    select(index) {
      if (this.chooseType === 1) {
        this.options = this.options.map((item, j) => ({...item, checked: index === j}))
      } else {
        this.options[index].checked = !this.options[index].checked
        this.options = [...this.options]
      }
    },
    async simpleSubmit() {
      const userChooses = []
      this.options.forEach(option => {
        if (option.checked) {
          userChooses.push(option.eventExamOptionsId)
        }
      })
      if (userChooses.length === 0) {
        return this.$Toast.info('请先选择')
      }
      const data = {
        answerUserId: this.userInfo.id || +new Date(),
        eventExamPaperId: this.eventExamPaperId,
        recordId: this.eventExamPaperRecordId,
        titleId: this.titleId,
        userChooses
      }
      const result = await simpleSubmit(data)
      if (result.code === 0) {
        this.$Toast.success('提交成功')
        this.$store.commit('setAnswerInfo', {
          showPanel: false
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.t {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.answer-panel {
}

.conatiner {
  padding: 16px;
}

.title-item {
  margin-bottom: 10px;
  .title-head {
    .index {
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
    .type {
      color: rgba(192, 196, 204, 1);
      margin: 0 4px;
    }
    .name {
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
      word-break: break-all;
    }
  }
}

.option-container {
  flex: 1;
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  .option-item {
    width: 48px;
    height: 48px;
    border: 2px solid #dcdfe6;
    text-align: center;
    line-height: 48px;
  }
  .option-item.radio {
    border-radius: 50%;
  }
  .option-item.checkbox {
    border-radius: 9px;
  }
  .option-item.active {
    border-color: #4465f3;
    background: #4465f3;
    color: #fff;
  }
}
</style>
<style lang="scss">
.answer-panel {
  .title-item {
    .van-cell {
      display: block;
    }
    .van-field__label {
      width: 100%;
    }
    .van-radio,
    .van-checkbox {
      margin-top: 10px;
    }
  }
}
.title-item-answer {
  .van-field__control {
    background: #eef0f3;
    border-radius: 8px;
    padding: 10px;
    margin-top: 10px;
  }
}
</style>
